import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';
import { themeConfig } from 'theme';
import { paletteStyles } from './paletteStyles';

export const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const organizationConfig = useOrganizationConfig();
  const isWhiteLabelingEnabled = organizationConfig?.whiteLabelingEnabled;
  const primaryColor = organizationConfig?.whiteLabelSettings?.primaryColor;

  const theme = createTheme({
    ...themeConfig,
    palette: paletteStyles({
      primaryColor: isWhiteLabelingEnabled ? primaryColor : undefined
    })
  });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
